import type { FeatureFlag } from "@common/types/featureFlags";

/**
 * The runtime feature flags this app offers in the admin view (AdminViewModal). Everything here is
 * sx-column's own business — the admin view itself knows only the generic FeatureFlag shape.
 *
 * A flag is off when the app loads and stays off until somebody turns it on, and turning it on
 * lasts until the page is refreshed. That is deliberate: these gate work that is not finished, so
 * the default has to be the behaviour we already ship, and nobody should be able to leave a half-
 * built feature switched on for the next session without meaning to.
 *
 * The enabled keys travel to the server on every calculation request (see runCalcThunk), so a key
 * is a wire value: pick it once and do not rename it.
 */
export const FEATURE_FLAG_RC_PROGRESS = "rcProgress";

/** Declared as keys rather than a FeatureFlag[] because the enabled state lives in uiSlice. */
export const FEATURE_FLAG_DEFINITIONS: Omit<FeatureFlag, "enabled">[] = [
  {
    key: FEATURE_FLAG_RC_PROGRESS,
    // The key predates the analysis and FEM-Design routes joining in, and stays as it is because
    // it is a wire value; the label is what says what it covers now.
    label: "Calculation progress reporting (#261)",
    description:
      "Ask the analysis, RC-Design and FEM-Design for their real calculation progress instead of " +
      "the interpolated bar. A service without the streamed routes answers 404 and the ordinary " +
      "route runs instead, so the calculation is the same either way.",
  },
];

/** Initial state: every declared flag, off. */
export const defaultFeatureFlags = (): Record<string, boolean> =>
  Object.fromEntries(FEATURE_FLAG_DEFINITIONS.map((d) => [d.key, false]));
